import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { spacing, Spacing } from "./Spacing";

interface IFlexCellProps {
    defaultPadding?: Spacing;
    smPadding?: Spacing;
    medPadding?: Spacing;
    lgPadding?: Spacing;
    xlPadding?: Spacing;

    defaultMargin?: Spacing;
    smMargin?: Spacing;
    medMargin?: Spacing;
    lgMargin?: Spacing;
    xlMargin?: Spacing;

    direction?: "vertical" | "horizontal";
    horizontalAlign?: "center";
    verticalAlign?: "center";
}

export const FlexContent = styled.div`
    display: flex;
    ${(props: IFlexCellProps) =>
        ((props.direction === "horizontal" &&
            props.horizontalAlign === "center") ||
            (props.direction !== "horizontal" &&
                props.verticalAlign === "center")) &&
        css`
            justify-items: center;
        `}
    ${(props: IFlexCellProps) =>
        ((props.direction === "horizontal" &&
            props.verticalAlign === "center") ||
            (props.direction !== "horizontal" &&
                props.horizontalAlign === "center")) &&
        css`
            align-items: center;
        `}
    ${(props: IFlexCellProps) =>
        props.direction === "horizontal"
            ? css`
                  flex-direction: row;
              `
            : css`
                  flex-direction: column;
              `}
    ${(props: IFlexCellProps) =>
        props.defaultPadding &&
        css`
            padding: ${spacing(props.defaultPadding)};
        `}
    ${(props: IFlexCellProps) =>
        props.defaultMargin &&
        css`
            margin: ${spacing(props.defaultMargin)};
        `}

    @media (min-width: 22.5rem) {
        ${(props: IFlexCellProps) =>
            props.smPadding &&
            css`
                padding: ${spacing(props.smPadding)};
            `}
        ${(props: IFlexCellProps) =>
            props.smMargin &&
            css`
                margin: ${spacing(props.smMargin)};
            `}
    }

    @media (min-width: 30rem) {
        ${(props: IFlexCellProps) =>
            props.medPadding &&
            css`
                padding: ${spacing(props.medPadding)};
            `}
        ${(props: IFlexCellProps) =>
            props.medMargin &&
            css`
                margin: ${spacing(props.medMargin)};
            `}
    }

    @media (min-width: 38.75rem) {
        ${(props: IFlexCellProps) =>
            props.lgPadding &&
            css`
                padding: ${spacing(props.lgPadding)};
            `}
        ${(props: IFlexCellProps) =>
            props.lgMargin &&
            css`
                margin: ${spacing(props.lgMargin)};
            `}
    }

    @media (min-width: 46.875rem) {
        ${(props: IFlexCellProps) =>
            props.xlPadding &&
            css`
                padding: ${spacing(props.xlPadding)};
            `}
        ${(props: IFlexCellProps) =>
            props.xlMargin &&
            css`
                margin: ${spacing(props.xlMargin)};
            `}
    }
`;
